import React, { useEffect, useState, useRef } from 'react'
import { Retrieve_personal_info } from '../../config/commonfunctions'
import Drawings from './components/Drawings/Drawings'
import Takepictures from './components/Takepictures/Takepictures'
import Writemessages from './components/Writemessages/Writemessages'
import Finaldisplay from './components/Finaldisplay/Finaldisplay'
import Allfaqs from './components/Allfaqs/Allfaqs'
import axios from 'axios'
import Pricing from './components/Pricing/Pricing'
import './Guestbookhowitworks.css'
import { Checkdevice } from '../../components'

const maintitle = 'Where Your Guests Leave Art,\n Not Just Words.'
const subtitle = 'An interactive digital guestbook where guests can draw, write, and upload photos, preserving every memory in one place.'


const DecorativeBorder = ({ children }) => {

    const device = Checkdevice()

    const cornerSVG = (rotation) => (
        <svg
            viewBox="0 0 25 25"
            style={{
                position: "absolute",
                width: 65,
                height: 65,
                color: "#b8a26a",
                transform: `rotate(${rotation}deg)`,
                transition: "0.3s",
            }}
        >
            <g
                className="corner-element"
                stroke="currentColor"
                strokeWidth="1px"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M6.75672e-07 24L14.9286 24L14.9286 6.77466L6.89005 6.77466" />
                <path d="M24 -7.72703e-08L24 14.9286L6.77472 14.9286L6.77472 6.89005" />
            </g>
        </svg>
    );

    return (
        <div
            style={{
                position: "relative",
                backgroundColor: 'rgb(255 254 247)',
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: '100%',
                boxSizing: "border-box",
            }}

        >

            <div
                style={{
                    position: 'absolute',
                    inset: 18,
                    borderTop: '3px solid rgb(184, 162, 106)',
                    pointerEvents: 'none',
                    width: 'calc(100% - 162px)',
                    display: 'flex',
                    placeItems: 'center',
                    left: 81
                }}
            />

            <div
                style={{
                    position: 'absolute',
                    inset: 18,
                    borderLeft: '3px solid rgb(184, 162, 106)',
                    pointerEvents: 'none',
                    height: 'calc(100% - 162px)',
                    display: 'flex',
                    placeItems: 'center',
                    top: 81
                }}
            />

            <div
                style={{
                    position: 'absolute',
                    inset: 18,
                    borderRight: '3px solid rgb(184, 162, 106)',
                    pointerEvents: 'none',
                    height: 'calc(100% - 162px)',
                    display: 'flex',
                    placeItems: 'center',
                    top: 81
                }}
            />


            <div
                style={{
                    position: 'absolute',
                    inset: 18,
                    borderBottom: '3px solid rgb(184, 162, 106)',
                    pointerEvents: 'none',
                    width: 'calc(100% - 162px)',
                    display: 'flex',
                    placeItems: 'center',
                    left: 81
                }}
            />


            {/* Top-left */}
            <div style={{ position: "absolute", top: 20, left: 20 }}>
                {cornerSVG(0)}
            </div>

            {/* Top-right */}
            <div style={{ position: "absolute", top: 20, right: 85 }}>
                {cornerSVG(90)}
            </div>

            {/* Bottom-left */}
            <div style={{ position: "absolute", bottom: 85, left: 20 }}>
                {cornerSVG(270)}
            </div>

            {/* Bottom-right */}
            <div style={{ position: "absolute", bottom: 85, right: 85 }}>
                {cornerSVG(180)}
            </div>

            {/* Content */}
            <div className={device === 'MOBILE' ? 'DecorativeBorder_rootmobile' : 'DecorativeBorder_root'} >
                {children}
            </div>
        </div>
    );
};



function Etsycontent() {

    const device = Checkdevice()

    const arrtxt = [
        'Set up guestbook, customise your theme, and generate QR code.',
        'Place the QR code at the reception, guests scans.',
        '🌸 Guests can doodle, 💌 leave messages, and 🖼️ upload photo.',
        'Display the guestbook on screen during the event.',
        `Download your guest's doodles & guestbook messages.`,
        'Scan the QR code anytime to revisit web-based guestbook.',
    ]

    if (device === 'WEB' || device === 'TABLET') {
        return <div className='Etsycontent_root'>
            <DecorativeBorder>
                <div className='Etsycontent_maintitle'>How it works?</div>
                {arrtxt.map((txt, index) => {
                    return <div key={txt + index} className='Etsycontent_txt'>{index+1 + '.  ' + txt}</div>
                })}
            </DecorativeBorder>
        </div>
    }
    else {
        return <div className='Etsycontent_rootmobile'>
            <div className='Etsycontent_maintitlemobile'>How it works?</div>
            {arrtxt.map((txt, index) => {
                return <div style={{display:'flex', flexDirection:'row', marginTop:25}}>
                    <div>{index + 1}</div>
                    <div key={txt + index} className='Etsycontent_txtmobile'>{txt}</div>
                </div>
            })}
        </div>
    }

}

function Guestbookhowitworks(props) {

    const [flowerdata, setFlowerdata] = useState([]);
    const [messages, setMessages] = useState([])
    const [images, setImages] = useState([])

    useEffect(() => {
        const controller = new AbortController();

        props.hidetopbar(false);
        const url = "https://asset.weavebliss.com/assets/guestbookhowitworks/datum.json"
        axios
            .get(url, { signal: controller.signal })
            .then(res => {
                const { flowers, messages, images } = res.data
                setFlowerdata(flowers)
                setMessages(messages)
                setImages(images)
            })
            .catch(err => {
                if (err.name !== "CanceledError") {
                    console.error(err);
                }
            });

        return () => controller.abort();
    }, []);


    const { token } = Retrieve_personal_info()

    // return  <div className='Guestbookhowitworks_root'>

    //         <div className='Guestbookhowitworks_maintitle'>{maintitle}</div>

    //         <div className='Guestbookhowitworks_subtitle'>{subtitle}</div>

    //         {(token && token.length > 0) ? null : <button className='Guestbookhowitworks_signup' onClick={() => props.history.push('/signup')}>Sign Up</button>}

    //         <Drawings backgroundColor={'#fffef6'} flowerdata={flowerdata} />

    //         <Takepictures backgroundColor={'#fffef6'} images={images} />

    //         <Writemessages backgroundColor={'#fffef6'} messages={messages} />

    //         <div className='Guestbookhowitworks_lookuproot'>
    //             <button
    //                 className='Guestbookhowitworks_lookupbtn'
    //                 onClick={() => { document.getElementById('iepreview_btninvisible').click() }}
    //             >
    //                 Browse Guestbook
    //                 <Link id="iepreview_btninvisible" to={'/guestbooklookup/weddingurlhandler/weddingmodpasscode'} target="_blank" />
    //             </button>
    //         </div>

    //     </div>



    return <div className='Guestbookhowitworks_root'>

        <div className='Guestbookhowitworks_maintitle'>{maintitle}</div>

        <div className='Guestbookhowitworks_subtitle'>{subtitle}</div>

        {(token && token.length > 0) ? null : <button className='Guestbookhowitworks_signup' onClick={() => props.history.push('/signup')}>Sign Up</button>}

        {/* <Drawings backgroundColor={'#fffef6'} flowerdata={[...flowerdata,...flowerdata,...flowerdata, ...flowerdata,...flowerdata,...flowerdata, ...flowerdata,...flowerdata,...flowerdata, ...flowerdata,...flowerdata,...flowerdata,]} /> */}
        <Drawings backgroundColor={'#fffef6'} flowerdata={[...flowerdata, ...flowerdata, ...flowerdata, ...flowerdata, ...flowerdata, ...flowerdata]} />

        <Takepictures backgroundColor={'#fffef6'} images={images} />
        <Writemessages backgroundColor={'#fffef6'} messages={messages} />
        <Finaldisplay backgroundColor={'#fffef6'} messages={messages} />
        <Allfaqs backgroundColor={'#fffef6'} openall={false} />
        <Etsycontent />
        <Pricing backgroundColor={'#fffef6'} />


    </div>


}
export default Guestbookhowitworks